import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useState } from 'react';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Horarios from './components/Horarios';
import Horario from './components/Horario';
import Carpeta from './components/Carpeta';
import EstudiantesHorarios from './components/estudiantes/EstudiantesHorarios';
import EstudaintesHorario from './components/estudiantes/EstudaintesHorario';
import EstudianteCarpeta from './components/estudiantes/EstudianteCarpeta';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('isAuthenticated') ? localStorage.getItem('isAuthenticated') : 'false');
  return (
    // <Router basename={process.env.PUBLIC_URL}> {/*SOLAMENTE PARA AMBEINTE DE PRUEBAS, NO FUNCIONA PARA AMBIETES LOCALES O PRODUCCION*/}
    <Router>
      <Routes>
        <Route path="/" element={<EstudiantesHorarios />} />
        <Route path="/*" element={<Navigate to={"/estudiantes/horarios"} />} />
        <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="/estudiantes/horarios" element={<EstudiantesHorarios />} />
        <Route path="/estudiantes/horario/:id" element={<EstudaintesHorario />} />
        <Route path="/estudiantes/carpeta/:id" element={<EstudianteCarpeta />} />
        <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
          <Route path="/horarios" element={<Horarios />} />
          <Route path="/horario/:id" element={<Horario />} />
          <Route path="/carpeta/:id" element={<Carpeta />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
